'use client';

import { SessionProvider } from 'next-auth/react';
import { OutilsSessionProvider } from '@/components/Outils/OutilsSessionContext';
import { OutilsSpinSessionProvider } from '@/components/Outils/OutilsSpinSessionContext';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <OutilsSessionProvider>
        <OutilsSpinSessionProvider>
          {children}
        </OutilsSpinSessionProvider>
      </OutilsSessionProvider>
    </SessionProvider>
  );
}















